import validatorsByFields from '@/utils/validations/validatorsByFields'
import { required } from 'vuelidate/lib/validators'
import {
  slugValidator,
  slugAsyncValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import placesSlugs from '@/services/gql/types/Places/queries/placesSlugs.gql'
const { title, subtitle } = validatorsByFields

export default ({ id, ctx, isNew, address }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, placesSlugs, ctx, 'places')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title,
    subtitle,
    slug: (() => {
      if (isNew) {
        return false
      }
      return {
        requred: { validator: required, message: validationErrorMessages.required },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        }
      }
    })(),
    categoryIds: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    address: {
      required: {
        validator: () => !!address?.address,
        message: 'Обязательное поле'
      }
    }
  }
}
